import { action } from 'satcheljs';

interface DiagnosticsActionParams {
    name: string;
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    customData: {
        [key: string]: any;
    };
    cId: string;
}

export const logDiagnostics = action(
    '__DIAGNOSTICS_LOG_DIAGNOSTICS',
    (action: DiagnosticsActionParams) => action
);
